import { storage } from './storage.js';
import { catalog } from './catalog.js';

/* Filtros elegidos en cada sección (categorías, calidad, ámbito): se guardan en el dispositivo por
   proveedor y espectador, para encontrarlos igual al volver. Las categorías son del proveedor, así
   que cada uno recuerda las suyas. */

const KEY = 'filters';
const MAX_USERS = 30;

export const filters = {
    get(section) {
        const all = storage.get(KEY, {}) || {};
        const mine = all[catalog.userKey] || {};
        return mine[section] || {};
    },

    set(section, patch) {
        const all = storage.get(KEY, {}) || {};
        const key = catalog.userKey;
        const mine = Object.assign({}, all[key]);
        mine[section] = Object.assign({}, mine[section], patch);
        mine.updated = Date.now();
        all[key] = mine;
        // Proveedores y espectadores que ya no existen no se acumulan para siempre.
        const keys = Object.keys(all);
        if (keys.length > MAX_USERS) {
            keys.sort((a, b) => (all[a].updated || 0) - (all[b].updated || 0)).slice(0, keys.length - MAX_USERS).forEach((k) => delete all[k]);
        }
        storage.set(KEY, all);
    }
};
